export default __webpack_public_path__ + "218c39a05c15889c821e1e68baf692c7.jpg";